export const eventHandlers = {
  PRODUCT_DETAILS_PAGE_VIEW: 'PRODUCT_DETAILS_PAGE_HIT',
  SELECT_ITEM_PRODUCT_DETAILS: 'SELECT_ITEM_PRODUCT_DETAILS_CLICK',
  PRODUCT_DETAILS_ADD_TO_CART: 'PRODUCT_DETAILS_ADD_TO_CART',
};
